'use client';

import React, { useState } from 'react';
import { twJoin } from 'tailwind-merge';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import { TechnicalDataDropdownProps } from './types/TechnicalDataDropdownProps';

export default function TechnicalDataDropdown({ title, properties }: TechnicalDataDropdownProps) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-t border-neutral-10 last:border-b">
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between gap-4 py-4 duration-200 ease-in hover:bg-neutral-5 md:py-7"
      >
        {title && <h3 className=" text-left text-md font-medium md:text-2xl">{title}</h3>}
        <ChevronUpIcon
          className={twJoin(
            'h-auto w-6 flex-shrink-0 text-primary-100 duration-200 ease-in',
            !open && 'rotate-180 transform',
          )}
        />
      </button>
      {open && (
        <div className="mb-5 overflow-hidden rounded-lg border border-neutral-10 md:mb-8">
          <table className="w-full table-fixed">
            <tbody>
              {properties?.map((property, index) => (
                <tr key={`property${index}`} className=" odd:bg-neutral-5">
                  <td className="w-1/2 p-2 align-top font-bold md:p-3 md:text-lg">
                    {property?.key}
                  </td>
                  <td className="w-1/2 p-2 md:p-3 md:text-lg">{property?.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
